import { render, staticRenderFns } from "./budgetDetail.vue?vue&type=template&id=e4960e66&scoped=true&"
import script from "./budgetDetail.vue?vue&type=script&lang=js&"
export * from "./budgetDetail.vue?vue&type=script&lang=js&"
import style0 from "./budgetDetail.vue?vue&type=style&index=0&id=e4960e66&scoped=true&lang=css&"
import style1 from "./budgetDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4960e66",
  null
  
)

export default component.exports